import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-preview-content',
  templateUrl: './preview-content.component.html',
  styleUrls: ['./preview-content.component.scss']
})
export class PreviewContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
